import { CLASSNAME } from '~/assistant/utils/constants';
import { fetchQuestion } from './api/fetches';
import Button from './components/Button';
import Chat from './components/Chat';
import Title from './components/Title';
import Iframe from './components/Iframe';
import Notice from './components/Notice';
import { bem } from '~/common/classname';
import CONFIGS from '~/common/configs';
import './styles.scss';

type Props = {
  [key: string]: any;
};

const App = {
  init(target: HTMLElement, data: Props) {
    const {
      productId,
      shop,
      logoImage,
      title = '쇼핑도우미',
      buttonText = '궁금한점 물어보기',
      botName = '쇼핑도우미 AI',
      botImage,
      headerTitle = '옥순 AI',
    } = data;
    if (shop && CONFIGS[shop]?.palette) {
      document.documentElement.style.setProperty(
        '--bai-primary',
        CONFIGS[shop].palette.primary
      );
    }

    fetchQuestion(productId).then((res) => {
      if (!res) {
        console.warn(`[WARNING]: 해당 상품과 관련된 AI Data가 없습니다.`);
        return;
      }

      const element = document.createElement('div');
      element.className = CLASSNAME;
      target.append(element);

      new Title({
        target: element,
        logoImage,
        title,
        buttonText,
        botName,
      });

      new Chat({
        target: element,
        data: res,
        botName,
        botImage,
        logoImage,
      });

      new Button({
        target: element,
        buttonText,
        onClick: () => {
          this.setIframe({ ...data, headerTitle });
        },
      });

      new Notice({
        target: element,
      });
    });
  },

  setIframe(data: Props) {
    const container: HTMLElement = document.querySelector(
      `.${bem([CLASSNAME, 'iframe'])}`
    );

    if (!container) {
      new Iframe(data);
    } else {
      container.style.visibility = 'visible';
    }
  },
};

export default App;
